/**
 * Created by yuanyina on 17/9/11.
 */
<template>
  <container bg="#f3f3f3">
    <scroller :on-infinite="infinite" ref="my_scroller" :no-data-text="noDataText" loading-layer-color="#888888" class="accountStyle">
      <div class="order-list">
        <mu-cell class="order-cell" :line="!!user.coreCustomerId" :height="6.8" v-for="(order, index) in accountList" :key="index">
          <div slot="left" class="list-cell-left">
            <div v-text="LOGTYPE[order.logType] ? LOGTYPE[order.logType]: '其他'" class="order-style"></div>
            <div class="order-time">{{order.systemOperationDate | formateDate}}</div>
          </div>
          <div slot="right">
            <div class="order-value" :class="order.amount > 0 ? 'activeClass' : ''"><span v-if="order.amount > 0">+</span>{{order.amount}}</div>
          </div>
        </mu-cell>
      </div>
      <!--上拉加载-->
      <!--custom infinite spinner -->
      <svg v-show="showScrollerLoading" class="spinner" slot="infinite-spinner" width="30" height="30"
           viewBox="0 0 60 60" stroke="#888888">
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(1 1)" stroke-width="3">
            <circle stroke="#dedede" cx="18" cy="18" r="18"></circle>
            <path d="M36 18c0-9.94-8.06-18-18-18">
              <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s"
                                repeatCount="indefinite"></animateTransform>
            </path>
          </g>
        </g>
      </svg>
    </scroller>
  </container>
</template>
<style lang="less" rel="stylesheet/less">
  @import "../../utils/_vars";

  .accountStyle {
    .order-list {
      padding-left: 2rem;
      color: @textDefault;

      .order-style {
        font-size: 1.6rem;
      }

      .order-time {
        font-size: 1.3rem;
      }

      .order-value {
        font-size: 2.0rem;
        padding-right: 2.0rem;
      }

      .activeClass {
        color: @primary;
      }
    }

    .loading-layer {
      font-size: 12px !important;
    }
  }
</style>
<script  >
  import webapi from '../../request/webapi';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import { logType } from '../../utils/config';

  export default {
    name: 'accountLog',
    data: function () {
      return {
        // 账户流水类型
        LOGTYPE: logType,
        accountList: [],
        pageSize: 10,
        pageNum: 1,
        noDataText: '',
        showScrollerLoading: false,
        orderCount: 0
      };
    },
    computed: {
      ...mapState({
        // 用户信息
        user: (state) => state.userState.user || {}
      })
    },
    filters: {
      formateDate: function (stringValue) {
        let value = Number(stringValue);
        if (!value) {
          return '';
        }
        return moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    methods: {
      // 获取账户流水
      async queryCustomerAccountLog() {
        try {
          let queryData = {
            pageSize: this.pageSize,
            pageNum: this.pageNum
          };
          console.log(queryData);
          let result = await webapi.account.queryCustomerAccountLog(queryData);
          if (result.statusCode === 200) {
            this.accountList = [...this.accountList, ...result.data.list];
            this.orderCount = Number(result.data.count);
            console.log(this.accountList);
          }
        }
        catch (e) {
          this.$showToast({ text: '数据加载失败，请您稍后重试' });
        }
        finally {
          this.$hideLoader();
        }
      },
      // 上拉加载
      async infinite(done) {
        if (this.pageNum === 1) {
          this.$showLoader({ text: '' });
        }

        if (this.pageNum !== 1 && this.orderCount === this.accountList.length) {
          this.noDataText = '没有更多了';
          setTimeout(() => {
            done(true);
          }, 1000);
          return;
        }

        await setTimeout(async () => {
          await this.queryCustomerAccountLog();
          if (this.pageNum === 1) {
            this.$hideLoader();
          }
          this.showScrollerLoading = true;
          this.pageNum++;
          setTimeout(() => {
            done();
          });
        }, 1000);
      }
    }
  };
</script>
